import { axiosWrapper } from "../../../axios_old"
import { formatDate } from "../../../formating"
import userAgentParser from "../../userAgentParser"

class SystemLog {
  static async getAll(token, params) {
    const {
      data: { data: raw }
    } = await axiosWrapper("GET", `log?${params}`, null, null, token)

    return raw.map((r) => new this(r))
  }

  static async getOne(token, id) {
    const { data: log } = await axiosWrapper("GET", `log/${id}`, null, null, token)
    return new this(log)
  }

  constructor(attributes = {}) {
    // assign all attributes dynamically
    for (const k in attributes) {
      this[k] = attributes[k]
    }

    this.endpoint = this.path
    this.date = formatDate({
      data: this.ts,
      actions: ["display+time"]
    })
  }

  get user() {
    return {
      id: this.userId || null,
      email: this.userEmail || null,
      name: this.userId ? `${this.userFirstName} ${this.userLastName}` : null,
      agent: this.userAgent ? userAgentParser(this.userAgent) : null,
      ipAddress: this.ipAddress
    }
  }

  get tableValues() {
    const osString = this.userAgent && userAgentParser(this.userAgent).short()
    const browserString = this.userAgent && userAgentParser(this.userAgent).browser()

    return {
      status: this.status,
      osString,
      browserString,
      userName: `${this.userFirstName} ${this.userLastName}`,
      method: this.method
    }
  }

  get username() {
    if (this.user) {
      return `${this.user.name} (${this.user.email}, ID ${this.user.id})`
    }
    return "No user."
  }

  get payloadKey() {
    switch (this.method) {
      case "GET":
        return "params"
      default:
        return "body"
    }
  }

  get color() {
    switch (this.status) {
      case 500:
        return "danger"
      case 404:
      case 403:
      case 401:
      case 400:
        return "warning"
      default:
        return "success"
    }
  }
}

export default SystemLog
